/*
 * @Author: your name
 * @Date: 2021-06-07 20:40:40
 * @LastEditTime: 2021-06-21 15:03:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/strategy.config.js
 */
// 策略平台
export default {
  CustomerPricingStrategyApproval: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/CustomerPricingStrategyApproval.vue'
    ),
  },
  ST_C_INITIAL_SHARE_ADD: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/ST_C_INITIAL_SHARE_ADD.vue'
    ),
  },
  STORESUPPLYSOURCE: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/STORESUPPLYSOURCE.vue'
    ),
  },
  SG_C_STORAGE_SOURCING_STRATEGY_BATCH: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/batchExcludeWarehouse.vue'
    ),
  },
  BANSAREAIMPORT: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/BANSAREAIMPORT.vue'
    ), // 导入
  },
  DELAYSET: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/delaySet.vue'
    ), // 延期
  },
  POSTPONECONFIRM: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/postponeConfirm.vue'
    ), // 延期
  },
  ENDTIMEUPDATEDIALOG: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/endTimeUpdateDialog.vue'
    ), // 修改结束时间
  },
  STRATEGYTIMEDIALOG: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/strategyTimeDialog.vue'
    ), // 修改结束时间
  },
  BATCHMODIFY: { //店铺策略》批量修改
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/batchModify.vue'
    ), // 店铺同步库存策略-（导入-同步策略明细
  },
  TABLELIST_COPY: { //复制
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/tablelist_copy.vue'
    ), // 复制
  },
  SYNCSTOCKSTRATEGYIMPORT: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/syncStockStrategyImport.vue'
    ),
  },
  PRODUCTSTRATEGYSHOPSCALEIMPORT: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/productStrategyShopScaleImport.vue'
    ), // 店铺商品特殊设置-编辑-多店铺比例-明细导入
  },
  BATCHUPDATEAUTOCHECK: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/batchUpdateAutocheck.vue'
    ), //订单自动审核列表->批量修改策略
  },
  BATCHUPDATETIME: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/batchUpdateTime.vue'
    ), //订单自动审核列表->批量修改时间
  },
  BATCHUPDATELOGISTICS: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterModal' */
      '@/views/modal/strategyPlatform/batchUpdateShop.vue'
    ), //店铺策略->批量修改物流公司
  },
};
